import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Box, Button, CircularProgress, Typography } from '@mui/material';
import { ArrowBack, Print } from '@mui/icons-material';
import StudentIdCard from '../components/StudentIdCard';
import { API_URL } from '../utils/api';

const TeachersCardsPrint = () => {
  const navigate = useNavigate();
  const [batch, setBatch] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');

  useEffect(() => {
    const load = async () => {
      try {
        const token = localStorage.getItem('token');
        if (!token) {
          navigate('/login');
          return;
        }
        const res = await fetch(`${API_URL}/api/employees/cards/teachers-batch`, {
          headers: { Authorization: `Bearer ${token}` },
        });
        const json = await res.json();
        if (!res.ok || !json.success) {
          throw new Error(json.error || 'Gagal memuat kartu guru');
        }
        setBatch(json.data);
      } catch (e) {
        setError(e.message);
      } finally {
        setLoading(false);
      }
    };
    load();
  }, [navigate]);

  if (loading) {
    return (
      <Box sx={{ display: 'flex', justifyContent: 'center', py: 8 }}>
        <CircularProgress />
      </Box>
    );
  }

  if (error || !batch?.cards?.length) {
    return (
      <Box sx={{ p: 4 }}>
        <Typography color="error">{error || 'Tidak ada kartu guru'}</Typography>
        <Button startIcon={<ArrowBack />} onClick={() => navigate('/teachers')} sx={{ mt: 2 }}>
          Kembali
        </Button>
      </Box>
    );
  }

  return (
    <Box sx={{ p: { xs: 2, md: 3 }, bgcolor: '#f1f5f9', minHeight: '100vh' }}>
      <Box className="no-print" sx={{ display: 'flex', gap: 2, mb: 3, flexWrap: 'wrap', justifyContent: 'center' }}>
        <Button variant="outlined" startIcon={<ArrowBack />} onClick={() => navigate('/teachers')}>
          Kembali
        </Button>
        <Button variant="contained" startIcon={<Print />} onClick={() => window.print()}>
          Cetak Semua ({batch.count} kartu)
        </Button>
      </Box>
      <Typography className="no-print" align="center" sx={{ mb: 2, fontWeight: 700 }}>
        Kartu Guru — {batch.count} orang
      </Typography>
      <Box className="class-cards-print-grid">
        {batch.cards.map((card) => (
          <Box key={card.id} className="class-cards-print-item">
            <StudentIdCard card={card} compact />
          </Box>
        ))}
      </Box>
      <style>{`
        .class-cards-print-grid {
          display: grid;
          grid-template-columns: repeat(auto-fill, minmax(200px, 1fr));
          gap: 16px;
          justify-items: center;
          max-width: 900px;
          margin: 0 auto;
        }
        @media print {
          .no-print { display: none !important; }
          body { background: white !important; margin: 0; padding: 0; }
          .class-cards-print-grid {
            grid-template-columns: repeat(4, 1fr);
            gap: 3mm;
            max-width: none;
            width: 100%;
            padding: 2mm;
          }
          .class-cards-print-item {
            break-inside: avoid;
            page-break-inside: avoid;
            display: flex;
            justify-content: center;
          }
          .student-id-card-sheet {
            box-shadow: none !important;
            margin: 0 auto;
          }
        }
      `}</style>
    </Box>
  );
};

export default TeachersCardsPrint;
